import React, { useCallback } from 'react';
import { Popover } from '@mantine/core';
import { useProjectState, viewportActions } from '@starflow/app/store';
import { translate } from '@shakkerai/util-i18n';
import { useDisclosure } from '@mantine/hooks';
import { Icon } from '@shakkerai/components';
import { cleanElements } from '../../../helpers/element';
import { showConfirmModal } from '@shakkerai/pro-components';
import { useGenHistoryVisible } from '@shakkerai/pro-gen-history';

const MAX_ELEMENTS = 120;

export const CleanTool = React.memo(() => {
  const elements = useProjectState('elements');
  const { toggleHistoryModelsBar } = useGenHistoryVisible();
  const [clearnerOpened, { open: showCleaner, close: hideCleaner }] = useDisclosure(false);

  // 如果有正在进行中的任务，也不应该展示这个按钮
  const showCleanTool = elements.length > MAX_ELEMENTS;

  const handleClearElements = useCallback(async () => {
    // 清理画布图片，需要判断图片上有没有正在进行中的任务
    // 先聚焦显示所有图片，然后弹窗确认是否清理
    viewportActions.fitView();

    const confirmed = await showConfirmModal({
      title: translate('clean_doublecheck_title'), // '确定要清空画布上的所有图片吗？',
      message: translate('clean_doublecheck_content'), //'清空画布后，你仍可以在历史记录中找到生成的图片',
    });

    if (confirmed) {
      cleanElements();
      viewportActions.zoomTo(0.25, 'screen-center');
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!showCleanTool) return null;

  return (
    <Popover opened={clearnerOpened} position="bottom-center">
      <Popover.Target>
        <button
          className="relative flex items-center justify-center w-5 h-5 hover:bg-[#f2f4f6]"
          onMouseEnter={showCleaner}
          onMouseLeave={hideCleaner}
        >
          <Icon className="shk-clean" fontSize={18} color="#7f7f7f" />
          <div className="absolute top-0 right-0 w-1.5 h-1.5 bg-[#ff7878] border border-white rounded-full" />
        </button>
      </Popover.Target>
      <Popover.Dropdown
        w={280}
        onMouseEnter={showCleaner}
        onMouseLeave={hideCleaner}
        className="w-[280px] -mt-2 p-0 pt-2 bg-transparent border-none"
      >
        <div className="relative flex flex-col px-3 py-6 bg-[#21252B] rounded-sm">
          <div className="absolute left-[136px] -top-1 w-2 h-2 rotate-45 bg-[#21252B]" />
          <span className="text-[13px] text-white font-medium">{translate('clean_title')}</span>
          <span className="mt-2 text-xs text-white">
            {translate('clean_content1')}
            <span className="text-primary">&ensp;{elements.length}&ensp;</span>
            {translate('clean_content2')}
          </span>
          <div className="mt-1 flex items-center flex-wrap text-xs text-white/80">
            <span>{translate('clean_content3')}</span>
            <button onClick={toggleHistoryModelsBar} data-role="gen-history-trigger" className="flex items-center mx-2">
              <Icon className="shk-history text-primary -translate-y-px" />
              <span className="text-primary">{translate('history_entrance')}</span>
            </button>
            <span>{translate('clean_content4')}</span>
          </div>
          <button
            onClick={handleClearElements}
            className="self-start mt-3 leading-[12px] border-b border-[#ff7878] text-[#ff7878] text-xs"
          >
            {translate('clean_button')}
          </button>
        </div>
      </Popover.Dropdown>
    </Popover>
  );
});
